import * as moment from 'moment';
import * as momentTimezone from 'moment-timezone';
import * as Common from 'common/enum';

import { fixedZero } from './utils';
import { TIME_ENUM } from 'common/enum';

export const convertToEndOfDateFromFormat = (
  date,
  format = Common.FORMAT_DATE_TIME.Date,
) => {
  try {
    return moment(date)
      .endOf('day')
      .unix();
  } catch (error) {
    return false;
  }
};

export const convertToStarOfDateFromFormat = (
  date,
  format = Common.FORMAT_DATE_TIME.Date,
) => {
  try {
    return moment(date)
      .startOf('day')
      .unix();
  } catch (error) {
    return false;
  }
};

export const convertUnixToDateWithTimezone = (
  unixTime,
  timeZone = Common.AUS_TIME_ZONE.UTC800.area,
  format = Common.FORMAT_DATE_TIME.Time,
) => {
  const date = momentTimezone.unix(unixTime);
  const dateWithSiteTimeZone = date.tz(timeZone).format(format);
  return dateWithSiteTimeZone;
};

export const convertUnixToFormatWithTimezone = (
  unixTime,
  timeZone = Common.AUS_TIME_ZONE.UTC800.area,
  format = Common.FORMAT_DATE_TIME.Time,
) => {
  const date = momentTimezone.unix(unixTime);
  const dateWithSiteTimeZone = date.tz(timeZone);
  return dateWithSiteTimeZone;
};

export const secondsToHms = time => {
  time = Number(time);
  var h = Math.floor(time / 3600);
  var m = Math.floor((time % 3600) / 60);
  var s = Math.floor((time % 3600) % 60);

  var hours = h > 0 ? h : 0;
  var minutes = m > 0 ? m : 0;
  var seconds = s > 0 ? s : 0;
  return { hours, minutes, seconds };
};

export const convertUnixToISOIgnoreTimezone = timestamp => {
  const date = new Date(timestamp * Common.TIME_ENUM.TimeUnixMillisecond);
  const isoDate = new Date(
    date.getTime() - date.getTimezoneOffset() * 60000,
  ).toISOString();
  return isoDate;
};

export const convertUnixToHoursMinute = unix_timestamp => {
  const timeObject = moment.unix(unix_timestamp);
  return timeObject.local().format('HH:mm');
};

export const stripTime = date => {
  date = moment(date);
  date.hours(0);
  date.minutes(0);
  date.seconds(0);
  date.milliseconds(0);
  return date;
};

//get start date and end date in month
export const getStartAndEndDay = (date, id, view) => {
  const start =
    moment(date)
      .subtract(1, view)
      .startOf(view)
      .startOf('day')
      .toDate()
      .getTime() / Common.TIME_ENUM.TimeUnixMillisecond;
  const end =
    moment(date)
      .add(1, view)
      .endOf(view)
      .startOf('day')
      .toDate()
      .getTime() / Common.TIME_ENUM.TimeUnixMillisecond;
  return { start, end, staffId: id };
};

export const getHoursMinutes = (startTime, endTime) => {
  const startHours = parseInt(moment(startTime, 'HH:mm').format('HH'));
  const endHours = parseInt(moment(endTime, 'HH:mm').format('HH'));

  const startMinute = parseInt(moment(startTime, 'HH:mm').format('mm'));
  const endMinute = parseInt(moment(endTime, 'HH:mm').format('mm'));

  return { startHours, endHours, startMinute, endMinute };
};

export const convertTimeToUnixWithSpecifyTimezone = (
  unixTime,
  offset = 0,
  format = Common.FORMAT_DATE_TIME.Time,
) => {
  if (unixTime) {
    try {
      return moment
        .unix(unixTime)
        .utcOffset(offset)
        .utc(offset)
        .unix();
    } catch (error) {
      return null;
    }
  }
  return null;
};

//From format to Time in seconds
export const convertTimeFromFormat = (
  time,
  format = Common.FORMAT_DATE_TIME.Time,
) => {
  try {
    const timeObj = moment(time, format);
    const unixTime =
      timeObj.get('hours') * 60 * 60 +
      timeObj.get('minutes') * 60 +
      timeObj.get('seconds');
    return unixTime;
  } catch (error) {
    return 0;
  }
};

//From Time in seconds to Moment Object
export const convertTimeToMomentObj = time => {
  try {
    let seconds = time;
    const days = Math.floor(seconds / (3600 * 24));
    seconds -= days * 3600 * 24;
    const hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;
    const minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;

    return moment(`${hours}:${minutes}:${seconds}`, 'HH:mm:ss');
  } catch (error) {
    return false;
  }
};

// Add timezone offset to unix time
export const modifyUnixTimeBaseOnTimezoneOffset = (time, offset) => {
  try {
    return time + offset * 60 * 60;
  } catch (error) {
    return false;
  }
};

//From Date in seconds to format
export const convertDateToFormat = (
  date,
  format = Common.FORMAT_DATE_TIME.Date,
) => {
  try {
    return moment(date * Common.TIME_ENUM.TimeUnixMillisecond).format(format);
  } catch (error) {
    return false;
  }
};

//From Date in format to ISO string
export const convertDateToISOFormat = (
  date,
  format = Common.FORMAT_DATE_TIME.Date,
) => {
  try {
    return moment.utc(date, format).toISOString();
  } catch (error) {
    return false;
  }
};

//From Date in format to seconds
export const convertDateFromFormat = (
  date,
  format = Common.FORMAT_DATE_TIME.Date,
) => {
  try {
    return moment(date).unix();
  } catch (error) {
    return false;
  }
};

//From ISO string to date format
export const convertISOFormatToDate = (
  date,
  format = Common.FORMAT_DATE_TIME.Date,
) => {
  if (!date) return false;
  try {
    return moment(date)
      .utc()
      .format(format);
  } catch (error) {
    return false;
  }
};

//From Time in seconds to format
export const convertTimeToFormat = (
  time,
  format = Common.FORMAT_DATE_TIME.Time,
) => {
  try {
    let seconds = time / 86400;
    const days = Math.floor(seconds / (3600 * 24));
    seconds -= days * 3600 * 24;
    const hours = Math.floor(seconds / 3600);
    seconds -= hours * 3600;
    const minutes = Math.floor(seconds / 60);
    seconds -= minutes * 60;

    return moment(`${hours}:${minutes}:${seconds}`, 'HH:mm:ss').format(format);
  } catch (error) {
    return false;
  }
};

export const isPastDate = currentDate =>
  currentDate && currentDate.isBefore(moment().startOf('day'));

export const isFutureDate = currentDate =>
  currentDate && currentDate.isAfter(moment().endOf('day'));

export const disabledDate = currentDate => {
  // Can not select days before today and today
  const afterDate = moment().add(7, 'days');
  const isValid =
    currentDate.isBefore(moment()) || currentDate.isAfter(afterDate);
  return isValid;
};

export function getTimeDistance(type) {
  const now = new Date();
  const oneDay = 1000 * 60 * 60 * 24;

  if (type === 'today') {
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);
    return [moment(now), moment(now.getTime() + (oneDay - 1000))];
  }

  if (type === 'week') {
    let day = now.getDay();
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);

    if (day === 0) {
      day = 6;
    } else {
      day -= 1;
    }

    const beginTime = now.getTime() - day * oneDay;

    return [moment(beginTime), moment(beginTime + (7 * oneDay - 1000))];
  }

  if (type === 'month') {
    const year = now.getFullYear();
    const month = now.getMonth();
    const nextDate = moment(now).add(1, 'months');
    const nextYear = nextDate.year();
    const nextMonth = nextDate.month();

    return [
      moment(`${year}-${fixedZero(month + 1)}-01 00:00:00`),
      moment(
        moment(
          `${nextYear}-${fixedZero(nextMonth + 1)}-01 00:00:00`,
        ).valueOf() - 1000,
      ),
    ];
  }

  const year = now.getFullYear();
  return [moment(`${year}-01-01 00:00:00`), moment(`${year}-12-31 23:59:59`)];
}

export function decimalToTimeCalculator(decimalTime) {
  //**NOTE :ignores case second decimal
  const hoursDefault = '00';

  const hoursRound = Math.floor(decimalTime);
  const hoursDecimal = decimalTime - hoursRound;
  const minOfDecimalTime = hoursDecimal * TIME_ENUM.TimeInHours;
  let hoursRoundAddPrefix = `${hoursRound}`;
  if (decimalTime > 0) {
    hoursRoundAddPrefix = `+${hoursRound}`;
  }

  return `${hoursRoundAddPrefix || hoursDefault}${
    minOfDecimalTime ? `:${minOfDecimalTime}` : ''
  }`;
}

export function getMinuteTimeZone(timeZoneRaw) {
  const hoursRound = Math.floor(timeZoneRaw);
  return (timeZoneRaw - hoursRound) * TIME_ENUM.TimeInHours;
}
